module.exports = "textarea.role {\n  max-width: 50%;\n  vertical-align: middle;\n  margin-left: 1em; }\n\n.remove, .active {\n  margin-left: 1em; }\n\n.margin-top {\n  margin-top: 0.5em; }\n\n.margin-left {\n  margin-left: 0.5em; }\n\n.error {\n  color: #FF0000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/createproject.component.scss
// module id = 349
// module chunks = 1